import React, { useState } from 'react';

import { useToast } from 'core/components/toast';
import { Discount } from '../discount';
import CommunityDriveDiscountModal from './community-drive-discount-modal';

const CommunityDrive = ({ ...discount }) => {
  const [isCMTModalOpen, setIsCMTModalOpen] = useState(false);
  const toast = useToast();

  return (
    <>
      <Discount {...discount} onAdd={() => setIsCMTModalOpen(true)} />
      {isCMTModalOpen && <CommunityDriveDiscountModal onClose={() => setIsCMTModalOpen(false)} />}
    </>
  );
};

export default CommunityDrive;
